import { Listing } from 'shared/interfaces';
import { ListingWorkflowStatusIdTypes } from 'shared/types';
import { petWorkflowStatuses } from 'utils/status/petWorkflowStatus';

export const isListingPetWorkflowStatusApproved = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusApprove(workflowStatusId);
};

export const isListingPetWorkflowStatusPendingReview = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusPendingReview(
    workflowStatusId
  );
};

export const isListingPetWorkflowStatusForwarded = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusForwarded(workflowStatusId);
};

export const isListingPetWorkflowStatusInProgress = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusInProgress(workflowStatusId);
};

export const isListingPetWorkflowStatusPendingBreeder = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusPendingBreeder(
    workflowStatusId
  );
};

export const isListingPetWorkflowStatusNotDefined = (
  listing: Listing
): boolean => {
  const workflowStatusId =
    listing.workflowStatusId || listing.workflowEntity?.currentWorkflowStatusId;

  if (!workflowStatusId) return false;

  return isListingWorkflowStatusIdPetWorkflowStatusNotDefined(workflowStatusId);
};

export const isListingWorkflowStatusIdPetWorkflowStatusApprove = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  petWorkflowStatuses.approve.workflowStatusIds.includes(workflowStatusId);

export const isListingWorkflowStatusIdPetWorkflowStatusPendingReview = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  petWorkflowStatuses.pendingReview.workflowStatusIds.includes(
    workflowStatusId
  );

export const isListingWorkflowStatusIdPetWorkflowStatusForwarded = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  petWorkflowStatuses.forwarded.workflowStatusIds.includes(workflowStatusId);

export const isListingWorkflowStatusIdPetWorkflowStatusInProgress = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  petWorkflowStatuses.inProgress.workflowStatusIds.includes(workflowStatusId);

export const isListingWorkflowStatusIdPetWorkflowStatusPendingBreeder = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  petWorkflowStatuses.pendingBreeder.workflowStatusIds.includes(
    workflowStatusId
  );

export const isListingWorkflowStatusIdPetWorkflowStatusNotDefined = (
  workflowStatusId: ListingWorkflowStatusIdTypes
): boolean =>
  !petWorkflowStatuses.notDefined.workflowStatusIds.includes(workflowStatusId);
